import { render } from "./index.vue?vue&type=template&id=3e7bc864&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3e7bc864&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7bc864"]])

export default __exports__